import { useLocation } from 'react-router-dom';
// import { v4 as uuidv4 } from 'uuid';
import { Env } from '@functions/index';
import settings from '@assets/settings';
import { useEffect, useState } from 'react';
import { Unavailability } from '@pages/Admin/Unavailability';

// const viewKey = 'identifier';

const usePage = () => {
  const [unavailability, setUnavailability] = useState<Unavailability[] | null>(null);

  const location = useLocation();

  const pageData = () => {
    // const identifier = localStorage.getItem(viewKey);

    /* When ignoring visits */
    /*
    if (location.pathname === '/ignore') {
      localStorage.setItem(viewKey, 'ignore');
      return;
    }

    /*
    if (identifier === 'ignore' || window.location.host?.startsWith('localhost')) {
      localStorage.setItem(viewKey, identifier);
      return;
    } */

    if (location.pathname?.includes('admin')) {
      return;
    }

    /*
    if (!identifier) {
      identifier = uuidv4() as string;
    }

    const page = location.pathname;
      */

    fetch(`${Env.apiUrl()}/rovi-sport/data`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-API-KEY': settings.apiKey,
      },
    })
      .then((resp) => resp.json())
      .then((data) => setUnavailability(data))
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    pageData();
  }, [location.pathname]);

  console.log(unavailability);

  return { unavailability };
};

export default {
  usePage,
};
